type ComponenteDotacion = number | string | null | undefined;

const esVacio = (valor: ComponenteDotacion) => valor === null || valor === undefined || valor === '';

// El total de dotacion no se carga a mano: es la suma de Administrativos, Produccion y
// Otros, con los vacios contados como cero. Si no se cargo ninguno devuelve null.
export const calcularTotalPersonal = (
    administrativos: ComponenteDotacion,
    personalProduccion: ComponenteDotacion,
    otrosPersonal: ComponenteDotacion
): number | null => {
    const componentes = [administrativos, personalProduccion, otrosPersonal];
    if (componentes.every(esVacio)) return null;

    return componentes.reduce<number>((total, valor) => {
        const numero = Number(valor);
        return total + (esVacio(valor) || Number.isNaN(numero) ? 0 : numero);
    }, 0);
};
